module.exports = __webpack_public_path__ + "img/header_bg3.55d39716.png";